module.exports = __webpack_public_path__ + "img/glo_logo.fc9ed775.svg";